import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';

import * as styles from './text-summit.module.scss';

const TextHighlight = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row className={clsx('d-flex flex-column flex-lg-row justify-content-between' )}>
          <div className='col col-lg-8 pe-lg-4 d-flex align-items-center'>
            {list.filter(x => x.__typename === 'ContentfulFlexBlock').map(item => (
              <div key={item.id}>
                {(item.showTitle && item.title) && <Heading type='h2'>{item.title}</Heading>}
                <RichText json={item.text} h2='fs-56' p={clsx('mb-3', item.textFontSize, item.textFontFamily)}/>
              </div>
            ))}
          </div>
          <div className={clsx('col', styles.listSummitAgenda)}>
            {list.filter(x => x.__typename !== 'ContentfulFlexBlock').map((item, index, {length}) => (
              <div className={clsx('text-center', {'pb-4 mb-3 border-bottom border-3 border-dark-grey-4': index !== length-1})} key={item.id}>
                {(item.showTitle && item.title) && <Heading type='h2'>{item.title}</Heading>}
                <RichText json={item.text} h3='fs-100 mb-0' h4='fs-72 mb-0' h5='fs-56' p='fs-36'/>
              </div>
            ))}
          </div>
        </Row>
      </Container>
    </Section>
  )
}

export default TextHighlight
